import * as React from 'react';
import Tabs from './tabs';
import { classNames } from '../../utils';

const Columns = ({ data }) => {
  const columnCount = data.column.length;
  const columnSpan = 12 / columnCount;

  switch (data.layout) {
    case 'ContentGrid':
      return (
        <div
          className="content-columns grid grid-cols-12"
          style={{
            backgroundColor: data.background_color ? data.background_color : 'transparent',
          }}
          id={data.attributes.html_id}
        >
          {data.column.map((column) => (
            <div key={column.title} className="col-span-6 flex flex-col">
              <h2 className="title">{column.title}</h2>
              <div
                className={classNames(
                  'content',
                  column.layout === 'ButtonLink' ? 'link-button' : 'link'
                )}
                dangerouslySetInnerHTML={{ __html: column.rich_text_editor }}
              />
            </div>
          ))}
        </div>
      );
    case 'Tabs':
      return (
        <div
          className="w-full"
          style={{
            backgroundColor: data.background_color ? data.background_color : 'transparent',
          }}
          id={data.attributes.html_id}
        >
          <div className="container">
            <span dangerouslySetInnerHTML={{ __html: data.title }}></span>
            <Tabs column={data.column} />
          </div>
        </div>
      );
    default:
      return (
        <div
          className={classNames('columns grid grid-cols-12 w-full', data?.attributes?.class)}
          style={{
            backgroundColor: data.background_color ? data.background_color : 'transparent',
          }}
          id={data.attributes.html_id}
        >
          {data.column.map((column) => (
            <div
              key={column?.title || column?.layout}
              className={classNames(
                column.layout === 'ImageOnly' ? 'row-start-1 md:row-start-auto' : '',
                `col-span-12 md:col-span-${columnSpan} content-wrapper`
              )}
            >
              {column.layout === 'ImageOnly' && column.image ? (
                <>
                  <img
                    src={column.image?.url}
                    className="w-full h-full object-contain"
                    alt={column.image?.description ? column.image.description : column.layout}
                  />
                </>
              ) : (
                <div className="inner-content col-span-12 md:col-span-6 row-start-1">
                  {column.title && <h2 className="title">{column.title}</h2>}
                  <div
                    className={classNames(
                      'content',
                      column.layout === 'ButtonLink' ? 'link-button' : 'link'
                    )}
                    dangerouslySetInnerHTML={{
                      __html: column.rich_text_editor,
                    }}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      );
  }
};

export default Columns;
